/* eslint-disable no-prototype-builtins */
/* eslint-disable no-case-declarations */
// @ts-nocheck
import * as types from 'redux/actions/forecast';
import copy from 'utils/cloneObj';
import { numberFormat } from 'utils/format';
import { mapExpandTaskData } from '../../utils/v1.1/mapExpandTaskData';

const MONTHS = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

const initialState = {
  loading: false,
  forecastData: [],
  claimData: [],
  taskData: [],
  dropdownTaskList: [],
  dropdownSubTaskList: {
    ungrouped: [],
    grouped: [],
  },

  dropdownCategoryList: [],
  dropdownResourceList: [],
  subTaskList: [],
  categoryList: [],
  months: [],

  pagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    currentPage: null,
    links: null,
  },

  deleteForecastDataSuccess: false,
  postForecastDataSuccess: false,

  expandedSection: {
    description: false,
    forecast: false,
  },

  filteredSection: {},
  filteredColumn: {
    all: false,
    quantity: false,
    duration: false,
    rate: false,
    unit: false,
    // contract_sum: true,
    budget_sum: true,
  },

  selectedRowForDeletion: {
    resources: [],
    subTasks: [],
    tasks: [],
  },

  expandedRow: {
    tasks: [],
    subTasks: [],
    cost_center: [],
  },

  searchedRow: {
    tasks: [],
    subTasks: [],
    resources: [],
  },
};

function forecastReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FORECAST_SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };

    case types.GET_FORECAST_DATA_SUCCESS:
      const expandedSection = getCollapsedSection(action.payload.config);

      const filteredSection = getFilteredSection(action.payload.config);
      return {
        ...state,
        loading: false,
        taskData: [...action.payload.tasks],

        months: [...action.payload.config.months],

        expandedSection: {
          ...expandedSection,
          ...state.expandedSection,
        },

        filteredSection: {
          ...filteredSection,
          ...state.filteredSection,
        },

        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
          links: action.payload.links,
        },
      };

    case types.GET_FILTERED_FORECAST_DATA_SUCCESS: {
      const expandedSection = getCollapsedSection(action.payload.config);

      const filteredSection = getFilteredSection(action.payload.config);

      return {
        ...state,
        loading: false,
        taskData: [...action.payload.tasks],

        months: [...action.payload.config.months, ...state.months],

        expandedSection: {
          ...expandedSection,
          ...state.expandedSection,
        },

        filteredSection: {
          ...filteredSection,
          ...state.filteredSection,
        },

        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
          links: action.payload.links,
        },
      };
    }

    case types.UPDATE_FORECAST_CELL_DATA:
      return updateForecastData(state, action);

    case types.POST_FORECAST_DATA_REQUEST:
      return {
        ...state,
        postForecastDataSuccess: false,
      };

    case types.POST_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        postForecastDataSuccess: true,
        forecastData: [],
        claimData: [],
      };

    case types.DELETE_FORECAST_DATA_REQUEST:
      return {
        ...state,
        deleteForecastDataSuccess: false,
      };

    case types.DELETE_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        deleteForecastDataSuccess: true,
        selectedRowForDeletion: {
          tasks: [],
          subTasks: [],
          resources: [],
        },
      };

    case types.UPDATE_CLAIM_DATA:
      return updateClaimData(state, action.payload);

    // case types.POST_CLAIM_DATA_SUCCESS:
    //   return updateClaimData(state, action.payload, action.res);

    // case types.GET_CLAIM_ROW_DATA_SUCCESS:
    //   return updateClaimData(state, action.payload, action.res);

    // case types.GET_DROPDOWN_TASK_LIST_SUCCESS:
    //   return getDropdownTaskList(state, action);

    // case types.GET_DROPDOWN_SUBTASK_LIST_SUCCESS:
    //   return getDropdownSubTaskList(state, action);

    // case types.GET_DROPDOWN_RESOURCE_LIST_SUCCESS:
    //   return getResourceList(state, action);

    case types.EXPAND_SECTION:
      return {
        ...state,
        expandedSection: {
          ...state.expandedSection,
          [action.payload.sectionName]:
            !state.expandedSection[action.payload.sectionName],
        },
      };

    case types.FILTER_COLUMN:
      return filterColumn(state, action);

    case types.FILTER_SECTION:
      return filterSection(state, action);

    case types.EXPAND_ROW:
      return expandRow(state, action);

    case types.EXPAND_ALL_ROW:
      return expandAllRow(state, action.payload);

    case types.COLLAPSE_ALL_ROW:
      return collapseAllRow(state);

    case types.SEARCH_FORECAST_DATA:
      return searchData(state, action);

    case types.SELECT_ROW_FOR_DELETION:
      return selectRowForDeletion(state, action);

    case types.UPDATE_SUB_TASK_PERCENTAGE:
      return updateSubTaskPercentage(state, action);

    case types.RESET_SELECTED_ROW_FOR_DELETION:
      return {
        ...state,
        selectedRowForDeletion: {
          resources: [],
          subTasks: [],
          tasks: [],
        },
      };

    case types.RESET_FORECAST_STATE:
      return initialState;

    default: {
      return state;
    }
  }
}

const updateSubTaskPercentage = (state, action) => {
  const clonedTaskData = copy(state.taskData);
  const clonedForecastData = copy(state.forecastData);
  const {
    payload: { taskId, subTaskId, month, percentage },
  } = action;
  const selectedTask = clonedTaskData.find((task) => task.id === taskId);

  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === subTaskId,
    );

    if (selectedSubTask) {
      if (selectedSubTask[month]) {
        selectedSubTask[month].percentage = percentage;
      } else {
        selectedSubTask[month] = {};
        selectedSubTask[month].percentage = percentage;
      }

      selectedSubTask.resource.forEach((resrc) => {
        if (!resrc[month]) resrc[month] = {};
        resrc[month].quantity = numberFormat(
          (percentage * resrc?.forecast?.quantity) / 100,
        );
        resrc[month].duration = resrc?.forecast?.duration;
        resrc[month].charge_rate = resrc?.forecast?.charge_rate;
        resrc[month].hasForecastChanged = true;

        const splitedDate = month.split('-');
        const date = `${splitedDate[0]}-${MONTHS[splitedDate[1]]}-1`;

        const newForecast = {
          id: resrc[month].id,
          resource: resrc.id,
          is_monthly: true,
          quantity: resrc[month].quantity,
          duration: resrc[month].duration,
          charge_rate: resrc[month].charge_rate,
          date,
        };

        const index = clonedForecastData.findIndex(
          (forecast) =>
            forecast.resource === resrc.id && forecast.date === date,
        );
        if (index !== -1) {
          clonedForecastData.splice(index, 1, newForecast);
        } else {
          clonedForecastData.push(newForecast);
        }
      });
    }
  }
  return {
    ...state,
    taskData: clonedTaskData,
    forecastData: clonedForecastData,
  };
};

const getCollapsedSection = (action) => {
  const section = {};
  action.months.forEach((month) => {
    section[`forecast${month}`] = true;
    section[`claim${month}`] = true;
  });
  return section;
};

const getFilteredSection = (action) => {
  const section = {};
  action.months.forEach((month) => {
    section[`forecast${month}`] = false;
    section[`claim${month}`] = false;
  });
  return section;
};

const filterSection = (state, action) => {
  const { payload } = action;
  const clonedfilteredSection = copy(state.filteredSection);
  if (payload.month === 'all') {
    state.months.forEach(
      (month) =>
        (clonedfilteredSection[`${payload.section}${month}`] = payload.checked),
    );

    return {
      ...state,
      filteredSection: clonedfilteredSection,
    };
  }

  clonedfilteredSection[`${payload.section}${payload.month}`] = payload.checked;

  return {
    ...state,
    filteredSection: clonedfilteredSection,
  };
};

const filterColumn = (state, action) => {
  const clonedFilteredColumn = copy(state.filteredColumn);

  if (action.payload.value === 'all') {
    const columns = ['quantity', 'duration', 'rate', 'unit'];
    // if filter is applied from dropdown
    if (action.payload.hasOwnProperty('checked')) {
      columns.push('budget_sum');
      columns.forEach((val) => {
        clonedFilteredColumn[val] = action.payload.checked;
      });
    } else {
      columns.forEach((val) => {
        clonedFilteredColumn[val] = !clonedFilteredColumn[val];
      });
    }

    const allColumnsSelected = Object.keys(clonedFilteredColumn)
      .filter((columnKey) => columnKey !== 'all')
      .reduce(
        (result, columnKey) => clonedFilteredColumn[columnKey] && result,
        true,
      );
    clonedFilteredColumn.all = allColumnsSelected;
  } else {
    clonedFilteredColumn[action.payload.value] = action.payload.checked;
    const allColumnsSelected = Object.keys(clonedFilteredColumn)
      .filter((columnKey) => columnKey !== 'all')
      .reduce(
        (result, columnKey) => clonedFilteredColumn[columnKey] && result,
        true,
      );

    clonedFilteredColumn.all = allColumnsSelected;
  }

  return {
    ...state,
    filteredColumn: clonedFilteredColumn,
  };
};

const expandRow = (state, action) => {
  const {
    payload: { type, taskId, subTaskId },
  } = action;

  const clonedExpandedRow = copy(state.expandedRow);
  if (type === 'task') {
    if (clonedExpandedRow.tasks.find((task) => task.id === taskId)) {
      clonedExpandedRow.tasks = clonedExpandedRow.tasks.filter(
        (task) => task.id !== taskId,
      );
    } else {
      clonedExpandedRow.tasks.push({ id: taskId });
    }
  } else if (type === 'cost_center') {
    if (clonedExpandedRow.cost_center.find((task) => task.id === taskId)) {
      clonedExpandedRow.cost_center = clonedExpandedRow.cost_center.filter(
        (task) => task.id !== taskId,
      );
    } else {
      clonedExpandedRow.cost_center.push({ id: taskId });
    }
  } else if (
    clonedExpandedRow.subTasks.find((subTask) => subTask.id === subTaskId)
  ) {
    clonedExpandedRow.subTasks = clonedExpandedRow.tasks.filter(
      (subTask) => subTask.id !== subTaskId,
    );
  } else {
    clonedExpandedRow.subTasks.push({ id: subTaskId });
  }

  return {
    ...state,
    expandedRow: clonedExpandedRow,
  };
};

const selectRowForDeletion = (state, action) => {
  const {
    payload: {
      type,
      checked,
      taskId,
      taskTitle,
      subTaskId,
      subTaskTitle,
      resourceId,
      resourceName,
    },
  } = action;

  const clonedSelectedRowForDeletion = copy(state.selectedRowForDeletion);
  let { tasks, subTasks, resources } = clonedSelectedRowForDeletion;

  if (type === 'task') {
    if (checked) {
      tasks = [...tasks, { id: taskId, title: taskTitle }];

      const selectedTask = state.taskData.find((task) => task.id === taskId);

      selectedTask.sub_task.forEach((subTask) => {
        subTasks = [...subTasks, { id: subTask.id, title: subTask.title }];

        subTask.resource.forEach((resource) => {
          resources = [...resources, { id: resource.id, name: resource.name }];
        });
      });
    } else {
      tasks = tasks.filter((task) => task.id !== taskId);

      const selectedTask = state.taskData.find((task) => task.id === taskId);

      selectedTask.sub_task.forEach((subTask) => {
        subTasks = subTasks.filter((subT) => subT.id !== subTask.id);

        subTask.resource.forEach((resource) => {
          resources = resources.filter((resrc) => resrc.id !== resource.id);
        });
      });
    }
  }

  if (type === 'subTask') {
    if (checked) {
      subTasks = [...subTasks, { id: subTaskId, title: subTaskTitle }];
      const selectedTask = state.taskData.find((task) => task.id === taskId);

      const selectedSubTask = selectedTask.sub_task.find(
        (subTask) => subTask.id === subTaskId,
      );

      selectedSubTask.resource.forEach((resource) => {
        resources = [...resources, { id: resource.id, name: resource.name }];
      });
    } else {
      subTasks = subTasks.filter((subT) => subT.id !== subTaskId);

      const selectedTask = state.taskData.find((task) => task.id === taskId);

      const selectedSubTask = selectedTask.sub_task.find(
        (subTask) => subTask.id === subTaskId,
      );

      selectedSubTask.resource.forEach((resource) => {
        resources = resources.filter((resrc) => resrc.id !== resource.id);
      });
    }
  }

  if (type === 'resource') {
    if (checked) {
      resources = [...resources, { id: resourceId, title: resourceName }];
    } else {
      resources = resources.filter((resrc) => resrc.id !== resourceId);
    }
  }

  clonedSelectedRowForDeletion.tasks = tasks;
  clonedSelectedRowForDeletion.subTasks = subTasks;
  clonedSelectedRowForDeletion.resources = resources;

  return {
    ...state,
    selectedRowForDeletion: clonedSelectedRowForDeletion,
  };
};

const doesIncludeString = (name, str) => {
  if (str.length > 1)
    return name
      .replace(/ /g, '')
      .toUpperCase()
      .includes(str.trim().replace(/ /g, '').toUpperCase());
  return false;
};

const searchData = (state, action) => {
  const { payload } = action;

  const clonedExpandedRow = copy(state.expandedRow);
  const clonedSearchedRow = copy(state.searchedRow);

  clonedExpandedRow.tasks = [];
  clonedExpandedRow.subTasks = [];
  clonedSearchedRow.tasks = [];
  clonedSearchedRow.subTasks = [];
  clonedSearchedRow.resources = [];
  clonedSearchedRow.cost_center = [];

  state.taskData.forEach((task) => {
    if (doesIncludeString(task.title, payload)) {
      clonedSearchedRow.tasks.push({ id: task.id });
    }

    task.sub_task.forEach((subTask) => {
      if (doesIncludeString(subTask.title, payload)) {
        clonedExpandedRow.tasks.push({ id: task.id });
        clonedSearchedRow.subTasks.push({ id: subTask.id });
      }

      subTask.resource.forEach((resrc) => {
        resrc.searched = false;

        if (doesIncludeString(resrc.name, payload)) {
          clonedExpandedRow.tasks.push({ id: task.id });
          clonedExpandedRow.subTasks.push({ id: subTask.id });
          clonedSearchedRow.resources.push({ id: resrc.id });
        }
      });
    });
  });

  return {
    ...state,
    expandedRow: clonedExpandedRow,
    searchedRow: clonedSearchedRow,
  };
};

const updateForecastData = (state, action) => {
  const clonedTaskData = copy(state.taskData);

  const {
    payload: { taskId, subTaskId, resource, field, value, headerType: month },
  } = action;
  const selectedTask = clonedTaskData.find((task) => task.id === taskId);

  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === subTaskId,
    );

    if (selectedSubTask) {
      const selectedResource = selectedSubTask.resource.find(
        (resrc) => resrc.id === resource,
      );

      if (selectedResource[month]) {
        if (field) {
          selectedResource[month][field] = value;

          const resourceForecast =
            selectedResource[month].duration *
            selectedResource[month].quantity *
            selectedResource[month].charge_rate;
          if (resourceForecast) {
            selectedResource[month].hasForecastChanged = true;
          }

          let forecastCost = 0;
          selectedSubTask.resource.forEach((resrc) => {
            if (resrc[month]) {
              forecastCost +=
                resrc[month].quantity *
                resrc[month].duration *
                resrc[month].charge_rate;
            }

            if (selectedSubTask[month]) {
              selectedSubTask[month].percentage = numberFormat(
                (forecastCost / selectedSubTask.budget_sum) * 100,
              );
              selectedSubTask[month].hasPercentageChanged = true;
            } else {
              selectedSubTask[month] = {};
              selectedSubTask[month].percentage = numberFormat(
                (forecastCost / selectedSubTask.budget_sum) * 100,
              );
              selectedSubTask[month].hasPercentageChanged = true;
            }
          });
        } else {
          selectedResource[month] = action.res;
        }
      } else {
        selectedResource[month] = {};
        selectedResource[month][field] = value;
      }
    }
  }

  let date;
  if (action.payload.isMonthly) {
    const splitedDate = month.split('-');
    date = `${splitedDate[0]}-${MONTHS[splitedDate[1]]}-1`;
  }

  const forecast = {
    id: action.payload.forecastId,
    resource: action.payload.resource,
    is_monthly: action.payload.isMonthly,
    ...(action.payload.isMonthly && { date }),
    quantity:
      action.payload.field === 'quantity'
        ? action.payload.value
          ? action.payload.value
          : 0
        : action.payload.quantity,
    duration:
      action.payload.field === 'duration'
        ? action.payload.value
          ? action.payload.value
          : 0
        : action.payload.duration,
    charge_rate:
      action.payload.field === 'charge_rate'
        ? action.payload.value
          ? action.payload.value
          : 0
        : action.payload.chargeRate,
  };

  return {
    ...state,
    taskData: clonedTaskData,
    forecastData: state.forecastData
      .filter(
        (forecast) =>
          !(forecast.resource === +resource && forecast.date === date),
      )
      .concat(forecast),
  };
};

const updateClaimData = (state, payload) => {
  const clonedTaskData = copy(state.taskData);

  const selectedTask = clonedTaskData.find(
    (task) => task.id === payload.taskId,
  );

  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === payload.subTaskId,
    );

    if (selectedSubTask) {
      selectedSubTask.claim_data[payload.month].percentage = payload.percentage;
    }
  }

  const claim = {
    ...(payload.claimId && { id: payload.claimId }),
    percentage: +payload.percentage,
    task: payload.subTaskId,
    start_date: payload.startDate,
    end_date: payload.endDate,
    is_monthly: true,
    month: payload.month,
    headerType: payload.month,
  };

  return {
    ...state,
    taskData: clonedTaskData,
    claimData: state.claimData
      .filter(
        (claim) =>
          !(claim.month === payload.month && claim.task === payload.subTaskId),
      )
      .concat(claim),
  };
};

const expandAllRow = (state, payload) => {
  // TODO CHANGE THIS CODE TO CUSTOM HOOKS
  const expandedRow = { tasks: [], subTasks: [], cost_center: [] };
  const value = mapExpandTaskData(payload?.data);
  // const t1 = performance.now();
  if (value?.task?.length) {
    expandedRow.tasks = value?.task?.map((each) => ({ id: each }));
  }
  if (value?.sub_task?.length) {
    expandedRow.subTasks = value?.sub_task?.map((each) => ({ id: each }));
  }
  if (value?.sub_sub_task?.length) {
    expandedRow.subTasks = [
      ...(!!value.sub_task.length && value.sub_task),
      ...value.sub_sub_task,
    ]?.map((each) => ({ id: each }));
  }
  if (value?.cost_center?.length) {
    expandedRow.cost_center = value?.cost_center?.map((each) => ({ id: each }));
  }
  // expandedRow.tasks = state.taskData.map((task) => ({ id: task.id }));

  // expandedRow.subTasks = state.taskData
  //   .map((task) => task.sub_task)
  //   .flat()
  // .map((subTask) => ({ id: subTask.id }));
  // const t2 = performance.now();
  return {
    ...state,
    expandedRow,
  };
};

const collapseAllRow = (state) => ({
  ...state,
  expandedRow: {
    tasks: [],
    subTasks: [],
    cost_center: [],
  },
});
export default forecastReducer;
